export default [
  {
    path: '/booking',
    name: 'BookingIndex',
    component: () => import('@/views/Booking/Index.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/booking/availableRooms',
  //   name: 'BookingAvailableRooms',
  //   component: () => import('@/views/Booking/AvailableRooms.vue'),
  // },
  // {
  //   path: '/booking/result',
  //   name: 'BookingResult',
  //   component: () => import('@/views/Booking/Result.vue'),
  // },
  // {
  //   path: '/booking/availableRooms/:rid(\\d+)',
  //   name: 'BookingAvailableRoomsDetail',
  //   component: () => import('@/views/Booking/Detail.vue'),
  // },
];
